import { APIError } from ".";

const giphyUrl = "https://api.giphy.com/v1/gifs";

export type GiphyGifData = {
  type: "gif";
  title: string;
  id: string;
  slug: string;
  url: string;
  bitly_url: string;
  embed_url: string;
  username: string;
  rating: string;
  content_url: string;
};

export type GiphyResponse = {
  data: GiphyGifData[];
  pagination: { total_count: number; count: number; offset: number };
};

const giphyApi = {
  token: "B0ZScYw9WECMOS2k7VHpbYgviDzWKSIJ",
  tokenString: "api_key=B0ZScYw9WECMOS2k7VHpbYgviDzWKSIJ",

  request(
    method: string,
    path: string,
    data: any,
    success: (data: any) => void,
    fail: (error: APIError) => void,
  ) {
    const xhr = new XMLHttpRequest();
    xhr.open(method, `${giphyUrl}${path}`);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          let response;
          try {
            response = JSON.parse(xhr.responseText);
          } catch (err) {
            console.error(err);
          }
          if (success) success(response);
        } else {
          let message;
          try {
            message = JSON.parse(xhr.responseText).message;
          } catch (_err) {
            if (fail)
              fail({
                status: xhr.status,
                message: "There was a problem with this request",
              });
          }
          if (fail) fail({ status: xhr.status, message });
        }
      }
    };
    xhr.send(data && JSON.stringify(data));
  },
};

const giphy = {
  trending(
    data: { page?: number },
    success: (data: GiphyResponse) => void,
    fail: (error: APIError) => void,
  ) {
    const { page = 1 } = data;
    giphyApi.request(
      "GET",
      `/trending?${giphyApi.tokenString}&limit=12&offset=${(page - 1) * 12}`,
      null,
      success,
      fail,
    );
  },
  search(
    data: { query: string; page?: number },
    success: (data: GiphyResponse) => void,
    fail: (error: APIError) => void,
  ) {
    const { query, page = 1 } = data;
    giphyApi.request(
      "GET",
      `/search?${giphyApi.tokenString}&q=${query}&limit=12&offset=${(page - 1) * 12}`,
      null,
      success,
      fail,
    );
  },
};

export default giphy;
